import { render } from "./GrupoDescCreate.vue?vue&type=template&id=049751ce&scoped=true"
import script from "./GrupoDescCreate.vue?vue&type=script&lang=js"
export * from "./GrupoDescCreate.vue?vue&type=script&lang=js"

import "./GrupoDescCreate.vue?vue&type=style&index=0&id=049751ce&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049751ce"]])

export default __exports__